import { apiService } from '../services/apiService';

export const passwordRecoveryService = {
	resetPassword: async (email: string, tenant: string) => {
		try {
			const response = await apiService.put('/users/password-recovery', {
				email,
				tenant,
			});
			return response.data;
		} catch (error: any) {
			throw new Error(error.response?.data?.message || 'Failed to reset password');
		}
	},
};
